import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AccountVM } from '../../models/AccountMasterVM';
import { BroadcastService } from '../infrastructure/broadcaster.service';
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable({
  providedIn: 'root'
})
export class ContainerReturnService {
  public SelectedAccountObj: BehaviorSubject<AccountVM>;
  public selectedAccountNo: any;
  public selectedAccountParentNo: any;
  public isEditMode = false;
  public productList: any = [];
  public redirectFrom: any;
  public returnRequestStatus: string;

  constructor(public broadcastService: BroadcastService,
    public configService: ConfigService,
    private networkService: NetworkService) {
    this.SelectedAccountObj = new BehaviorSubject<AccountVM>(null);
    this.containerReturnRequestId = new BehaviorSubject(0);
  }

  webOrderNumberAndSplitId: any;
  containerReturnRequestId: BehaviorSubject<number>;

  // Get Account detail data for Account dropdown
  public getAccountList() {
    return this.networkService.getRequest(this.configService.cppContainerReturnsAccountListUrl);
  }
  public getReturnType() {
    return this.networkService.getRequest(this.configService.cppContainerReturnsTypeUrl);
  }
  cppContainerReturnsTypeUrl;

  public setContainerReturnRequestId(value: number) {
    this.containerReturnRequestId.next(value);
  }

  public setRedirectionFrom(value) {
    this.redirectFrom = value;
  }

  getSelectedAccountNo() {
    return this.selectedAccountNo;
  }

  setSelectedAccountNo(selectedAccountNo) {
    this.selectedAccountNo = selectedAccountNo;
  }

  // Get account user
  public getAccountUser(accountNumber) {
    return this.networkService.getRequest(this.configService.accountUserContainerReturnRequestUrl + '?accountNumber=' + accountNumber);
  }

  getSelectedParentAccountNo() {
    return this.selectedAccountParentNo;
  }

  // Get invoiced product list for grid
  public getInvoicedProductItems(filters) {
    return this.networkService.postRequest(this.configService.getContainerReturnInvoicedProductListUrl, filters);
  }

  setSelectedParentAccountNo(selectedAccountParentNo) {
    this.selectedAccountParentNo = selectedAccountParentNo;
  }

  getEditModeStatus() {
    return this.isEditMode;
  }

  setEditModeStatus(isEditMode) {
    this.isEditMode = isEditMode;
  }
  getProductList() {
    return this.productList;
  }

  setProductList(productList) {
    this.productList = productList;
  }
  public AccountChange(obj: AccountVM) {
    this.SelectedAccountObj.next(obj);
  }

  public setReturnRequestStatus(value: string) {
    this.returnRequestStatus = value;
  }

  // Get Deliver To Facility List
  public getDeliverToFacilityList(accountNumber, shipToAccountParentNumber) {
    const url = this.configService.getAPIPath(this.configService.getCppContainerReturnsDeliverToFacilityDataUrl,
      { accountNumber: accountNumber, shipToAccountParentNumber: shipToAccountParentNumber });
    return this.networkService.getRequest(url);
  }

  public getReturnRequestReport(filters) {
    return this.networkService.postRequest(this.configService.getContainerReturnsRequesReporttUrl, filters);
  }

  // Get return request header id by inputs value for draft
  public getDraftReturnRequest(accountNumber) {
    const url = this.configService.getAPIPath(this.configService.getDraftContainerReturnsRequestDataUrl,
      { accountNumber: accountNumber });
    return this.networkService.getRequest(url);
  }

  // Get Edit request detail
  public getEditRequestDetail(requestId) {
    return this.networkService.getRequest(this.configService.getContainerReturnsRequestEditDetailDataUrl + '?requestId=' + requestId);
  }

  public submitReturnRequest(data) {
    return this.networkService.postRequest(this.configService.saveContainerReturnsRequestItemsUrl, data);
  }

  // Get Item Number List
  public getItemNumberList() {
    return this.networkService.getRequest(this.configService.getContainerReturnsItemNumberDataUrl);
  }

  // Get Landing Grid Data
  public getContainerReturnRequestList(filters) {
    return this.networkService.postRequest(this.configService.getContainerReturnRequestListUrl, filters);
  }

  // Get Banner Message url
  public getBannerMessage() {
    return this.networkService.getRequest(this.configService.containerReturnsBannerMessageUrl);
  }

  // submit to jde
  public submitToJDEReturnRequest(data) {
    return this.networkService.postRequest(this.configService.submitToJDEContainerReturnsRequestItemsUrl, data);
  }

  // Delete Order
  public deleteRequest(returnRequestId) {
    return this.networkService.postRequest(this.configService.deleteContainerReturnRequestUrl, returnRequestId);
  }

  // check if OTI Orders Exist for Customer PO and ship to account
  public checkOTIOrders(shipToAccount, customerPO) {
    return this.networkService.getRequest(this.configService.containerReturnsCheckOTIOrdersUrl + '?shipToAccount=' + shipToAccount + '&customerPO=' + customerPO);
  }
}
